import { GALLERY_GROUP_SLUG_UNGROUPED, type GalleryGroupSlugType, isGalleryGroupSlugType } from '@/defs/gallery'
import { type Dict } from '@/defs/misc'
import { slugify } from '@/utils/commonUtil'

const singularize = (slug: string) => slug.replace(/ies$/, 'y').replace(/([^s])s$/, '$1')

const RENAMES: Dict<GalleryGroupSlugType> = {
  'type-basic': 'type-land',
  'type-nonbasic': 'type-land',
}

export const parseGalleryTypeSlug = (header?: string): GalleryGroupSlugType => {
  const slug = `type-${singularize(slugify(header || ''))}`
  return RENAMES[slug] || (isGalleryGroupSlugType(slug) ? slug : GALLERY_GROUP_SLUG_UNGROUPED)
}
